
import clsx from 'clsx'
import {KTSVG} from '../../../../../_metronic/helpers'
import { Link } from 'react-router-dom';

type Props = {
  className?: string
  svgClassName?:string
  bgColor?: string
  title?: string
  subtitle?: string
  svgPath: string
  link:string
  type?:string //external/internal
  disabled?:boolean 
}
const MenuCard = ({
  title,
  subtitle,
  className,
  svgPath,
  link,
  type="internal",
  svgClassName,
  disabled=false
}: Props) => {
  const redirect = !disabled? (type==='internal'?
    (
      <Link to={link}>
        <h4 className='fw-bold mb-2 nav-link-custom'>{title}</h4>
      </Link>
    ):
    (
      <a href={link} target='_blank' rel="noreferrer">
        <h4 className='fw-bold mb-2 nav-link-custom'>{title}</h4>
      </a>
    )
  ):(
    <h4 className='fw-bold mb-2 text-muted'>{title}</h4>
  )
  return (
    <div
      className={clsx('card h-100 bgi-no-repeat bgi-size-cover', className)}
    >
      {/* begin::Body */}
      <div className='card-body d-flex flex-row justify-content-start p-4'>
        <div className="icon d-flex align-items-center justify-content-center h-100">
          <KTSVG path={svgPath} className={clsx(" svg-icon-5hx", svgClassName,{
            'svg-icon-primary': !disabled
          })} />
        </div>
        {/* begin::Title */}
        <div className='d-flex flex-column align-items-start justify-content-center h-100'>
            {redirect}
          <div className='mb-2 fw-normal fs-7 text-muted'>{subtitle}</div>
        </div>
        {/* end::Title */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {MenuCard}
